import React from 'react';
import { DebugPanel } from '../../lib/debug-console/panel';
// The GlobalDebugPanel is now just a wrapper around the SDK's DebugPanel.
// The configuration (sources, actions) should ideally be passed to the DebugProvider
// in App.tsx or index.tsx. For backward compatibility, the SDK's DebugPanel
// renders exactly what this component used to render.
export function GlobalDebugPanel() {
  return <DebugPanel data-id="element-2349" />;
}